<template>
	<div class="d-flex align-center">
		<a
			:href="attachment.url"
			:title="attachment.file_real_name || attachment.filename"
			target="_blank"
			class="upload-note mr-4"
		>
			<ResourceFileIcon
				class="icon_style"
				:url="attachment.url"
				:fileName="attachment.filename"
			/>
			<p class="upload-type">
				{{ fileIconName(attachment.filename) }}
			</p>
		</a>
	</div>
</template>

<script>
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import ResourceFileIcon from '@/components/Resource/ResourceFileIcon.vue'

Vue.use(VueScrollTo)

export default {
	name: 'PostAttachments',

	components: {
		ResourceFileIcon,
	},

	props: {
		attachment: {
			type: Object,
			default: () => {
			},
		},
	},

	data() {
		return {
			fileColors: [
				{ color: '#50bee8', ext: ['jpg', 'jpeg', 'psd'] },
				{ color: '#6678aa', ext: ['bmp'] },
				{ color: '#a066aa', ext: ['png', 'gif'] },
				{ color: '#f15642', ext: ['pdf'] },
				{ color: '#50bee8', ext: ['doc', 'docx'] },
				{ color: '#638674', ext: ['rtf'] },
				{ color: '#f15642', ext: ['ppt'] },
				{ color: '#84bd5a', ext: ['xls', 'xlsx'] },
				{ color: '#f7b84e', ext: ['mp3', 'wav', 'flac'] },
				{ color: '#f7b84e', ext: ['avi', 'mp4', 'mpeg'] },
				{ color: '#576d7e', ext: ['txt'] },
				{ color: '#e59f2b', ext: ['zip', 'rar', '7z', 'gz', 'gzip', 'bzip'] },
				{ color: '#41a8e1', ext: ['url'] },
			],
		}
	},

	methods: {
		fileIconName(filename) {
			return (filename || '').split('.').pop().substring(0, 4)
		},
	},
}
</script>

<style lang="scss">
.icon_style{
	margin: -15px 0 50px 0;
}
.attachment-wrapper{
	width: 50px;
	height: 50px;
	margin-top: 3px;
}
.upload {
	&-note {
		margin:0 0 0 0;
		display: inline-block;
		position: relative;
		color: #fff;
		width: 40px;
		height: 40px;
		text-align: center;
		overflow: hidden;
		padding-top: 13px;
		font-size: 13px;
		text-decoration: none !important;
		-webkit-border-radius: 5px;
		-moz-border-radius: 5px;
		border-radius: 3px !important;
		flex-shrink: 0;
	}

	&-note:before {
		content: '';
		position: absolute;
		top: 0;
		right: 0;
		border-style: solid;

		border-width: 5px;
		border-color: #fff #fff rgb(0 0 0 / 25%) rgb(0 0 0 / 25%);
		-webkit-border-bottom-left-radius: 3px;
		-moz-border-radius: 0 0 0 3px;
		border-radius: 0 0 0 3px;

		display: block;
		width: 0;
		-moz-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.3), -1px 1px 1px rgba(0, 0, 0, 0.2);
		box-shadow: 0 1px 1px rgba(0, 0, 0, 0.3), -1px 1px 1px rgba(0, 0, 0, 0.2);
	}

	&-type {
		text-decoration: none;
		color: white;
		font-size: 12px;
		font-family: Montserrat;
		font-weight: bold;
		text-transform: uppercase;

		&:hover {
			color: #1c40ba;
		}
	}

	&-name {
		color: rgb(74, 74, 74);
		font-size: 15px;
		font-family: Montserrat;
		font-weight: 400;
		line-height: 18px;
		word-break: break-word;
	}
}
</style>
